import React from "react";

interface HikeIconProps {
  fill?: string;
  className?: string;
  width?: string | number;
  height?: string | number;
}

const HikeIcon: React.FC<HikeIconProps> = ({
  fill = "currentColor",
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 119.000000 116.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g
        transform="translate(0.000000,116.000000) scale(0.100000,-0.100000)"
        fill={fill}
        stroke="none"
      >
        <path
          d="M514 1036 c-42 -64 -60 -83 -74 -79 -12 3 -29 -9 -56 -41 -45 -55
-58 -60 -88 -41 -23 15 -25 13 -109 -83 -47 -54 -106 -120 -132 -146 l-48 -47
16 -82 c44 -221 207 -395 423 -451 78 -20 210 -20 293 -1 200 48 373 216 426
415 19 72 20 140 1 140 -16 0 -101 86 -172 174 -43 53 -48 57 -60 41 -19 -26
-38 -14 -90 57 -25 35 -50 65 -56 67 -5 2 -16 -7 -25 -19 l-15 -22 -27 26
c-15 14 -52 60 -82 101 -29 41 -57 75 -61 75 -5 0 -33 -38 -64 -84z m69 -76
c6 -63 5 -67 -36 -140 -43 -76 -59 -89 -65 -54 -8 40 -22 37 -73 -14 -29 -29
-53 -52 -55 -52 -2 0 -4 12 -4 28 0 62 14 103 47 142 29 34 38 39 50 28 16
-13 10 -20 75 85 47 78 52 75 61 -23z m241 -125 c20 -42 36 -78 36 -80 0 -14
-93 56 -115 85 -29 40 -35 72 -8 44 16 -16 18 -15 31 5 8 11 16 21 17 21 2 0
20 -34 39 -75z m-514 -56 c-22 -43 -77 -109 -91 -109 -5 0 -9 7 -9 16 0 12
-10 8 -40 -16 -22 -17 -40 -27 -40 -22 0 21 107 147 124 146 9 -1 22 6 28 16
6 10 19 15 29 13 17 -5 17 -7 -1 -44z m696 -78 c19 -29 32 -56 28 -60 -3 -3
-31 8 -62 25 -51 28 -56 33 -59 67 -1 27 2 37 13 37 8 0 14 6 14 13 1 14 18
-7 66 -82z m-319 -3 c29 -13 53 -28 53 -34 0 -15 -35 -46 -43 -37 -8 8 -107
-37 -107 -49 0 -8 8 -10 105 -29 79 -14 105 -32 105 -68 0 -45 -43 -73 -184
-121 -136 -46 -183 -77 -201 -131 -14 -40 -49 -52 -59 -21 -14 44 44 126 114
161 19 10 78 33 131 50 53 17 105 38 115 46 23 17 20 18 -85 39 -84 18 -113
38 -109 75 2 19 15 32 51 51 31 16 45 30 42 39 -6 16 3 51 13 51 4 0 31 -10
59 -22z m-366 -130 c23 -29 24 -38 2 -38 -14 0 -12 -4 7 -25 l23 -25 -23 0
-23 0 21 -23 c27 -29 28 -37 2 -30 -11 3 -20 1 -20 -3 0 -5 9 -15 20 -22 25
-15 26 -32 1 -32 -10 0 -22 -8 -26 -17 -6 -17 -7 -17 -18 -2 -7 9 -21 18 -32
20 -19 4 -19 5 3 27 27 27 28 32 0 32 l-21 0 23 25 c19 21 21 25 7 25 -21 0
-22 14 -2 30 8 7 15 16 15 21 0 5 -7 6 -15 3 -21 -9 -19 6 7 33 26 28 26 28
49 1z"
        />
      </g>
    </svg>
  );
};

export default HikeIcon;
